import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTerminal,
  faHome,
  faExternalLinkAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  faGithub,
  faLinkedin,
  faHtml5,
  faCss3,
  faJs,
  faReact,
  faChrome,
  faGitAlt,
  faSass,
  faBootstrap,
  faAws,
  faSketch,
  faNodeJs,
} from "@fortawesome/free-brands-svg-icons";

library.add(
  faGithub,
  faLinkedin,
  faHtml5,
  faCss3,
  faJs,
  faReact,
  faChrome,
  faGitAlt,
  faSass,
  faBootstrap,
  faAws,
  faTerminal,
  faSketch,
  faNodeJs,
  faHome,
  faExternalLinkAlt
);
